import { Divider, Grid, Paper, Skeleton, useMediaQuery } from "@mui/material";

import usePlatform from "@/hooks/usePlatform";

const RoutesItemSkeleton = () => {
  const { isPc } = usePlatform();

  const isBreakPoint = useMediaQuery("(min-width:900px)");

  return (
    <Grid
      container
      className={`p-[20px]`}
      sx={{
        ".MuiSkeleton-root": {
          transform: "scale(1)",
        },
      }}
    >
      <Grid item xs={12} md={7}>
        <div className="flex items-center h-[100%] w-[100%]">
          <Skeleton
            width={isBreakPoint ? 100 : 50}
            height={isBreakPoint ? 50 : 30}
            animation="wave"
          />
          <div className="text-center flex-1 ml-[20px] md:ml-[200px] space-y-[10px]">
            <Skeleton width={200} height={30} animation="wave" />
            <Skeleton width={200} height={30} animation="wave" />
          </div>
        </div>
      </Grid>

      <Grid
        item
        xs={12}
        md={5}
        style={{
          marginTop: isPc ? 0 : "20px",
        }}
      >
        <div className="space-x-[20px] flex items-center justify-between  md:justify-end h-[100%]">
          <Skeleton width={100} height={50} />
          <Skeleton width={20} height={20} />
        </div>
      </Grid>
    </Grid>
  );
};

const RoutesListSkeleton = (props: { count: number }) => {
  const list = new Array(Math.max(props.count, 1)).fill("");
  return (
    <div className="mt-[12px]">
      <div className="flex items-center justify-between pb-[20px]">
        <Skeleton variant="rounded" width={100} height={25} />
        {/* <Skeleton variant="rounded" width={100} height={25} /> */}
      </div>
      <Paper elevation={1}>
        {list.map((_, index) => {
          return (
            <div key={index}>
              <RoutesItemSkeleton />
              {index < props.count - 1 ? <Divider /> : null}
            </div>
          );
        })}
      </Paper>
    </div>
  );
};

export default RoutesListSkeleton;
